import { Directive, Input, HostBinding } from '@angular/core';
import { BaseDirective } from '../base/_base.directive';

@Directive({
  selector: 'circle-icon, [circleIcon]',
  exportAs: 'circle-icon'
})
export class CircleIconDirective extends BaseDirective {

  // ['small']
  @Input() set size(size: string) {
    if (this.iconSize) {
      this.removeClassName('size-' + this.iconSize);
    }
    this.iconSize = size;
    this.setClassName(`size-${size}`);
  }

  @Input() set color(color: string) {
    if (this.iconColor) {
      this.removeClassName('circle-' + this.iconColor);
    }
    this.iconColor = color;
    this.setClassName(`circle-${color}`);
  }

  @HostBinding('class.circle-icon') iconClass: boolean = true;

  private iconSize: string;
  private iconColor: string;

}
